const permissions = {
  label: "Permissions",
  label_plural: "Permissions",
  read: "View",
  update: "Modify",
  create: "Create",
  created: "Created",
  updated: "Updated",
  entity: {
    label: "Entity",
    label_plural: "Entities",
    id: "Entity ID",
    name: "Entity Name",
    description: "Description",
  },
  scope: {
    label: "Scope",
    label_plural: "Scopes",
    id: "Scope Type",
  },
  role: {
    label: "Role",
    label_plural: "Roles",
    id: "Role ID",
    name: "Name",
    description: "Description",
    tenantID: "Customer Division ID",
  },
  permission: {
    title: "Permissions",
    read_none: "Disable permissions page",
    read_role: "Can view permissions page",
    update_none: "Cannot modify permissions",
    update_role: "Can modify permissions",
  },
  permit: {
    title: "Permits and Permit Types",
    read_none: "Disable Permits and Permit Types pages",
    read_role: "Can view Permits and Permit Types pages",
    read_role_PM: "Can view Permits and Permit Types pages for assigned properties",
    update_none: "Cannot modify Permits and Permit Types",
    update_role: "Can modify Permits and Permit Types",
    update_role_PM: "Can modify Permits and Permit Types for assigned properties",
    create_none: "Cannot create Permits and Permit Types",
    create_role: "Can create Permits and Permit Types",
    create_role_PM: "Can create Permits and Permit Types for assigned properties",
  },
  user: {
    title: "Users",
    read_none: "Disable all users pages",
    read_role: "Can view users list and user details",
    read_role_PM: "Can view users list and user details for assigned properties",
    update_none: "Cannot modify other users",
    update_assignedToUser: "Can only edit their own user profile on the My Account tab",
    update_role: "Can modify all users and user settings",
    create_none: "Cannot create new users",
    create_role: "Can create new users",
  },
  contact: {
    title: "Contacts",
    read_none: "Disable all contacts pages",
    read_role: "Can view contacts details page",
    read_role_PM: "Can view contacts details page for assigned properties",
    update_none: "Cannot use the contacts edit page",
    update_role: "Can modify all contacts",
    update_role_PM: "Can modify contacts associated with assigned properties",
    create_none: "Cannot use the create contacts page",
    create_role: "Can use the create contacts page",
  },
  job: {
    title: "Jobs",
    read_none: "Disable all job pages",
    read_createdByUser: "Can view details for jobs they created",
    read_assignedToUser: "Can only view jobs assigned to them",
    read_role: "Can view job details for all jobs",
    read_role_PM: "Can view all jobs for assigned properties",
    update_none: "Cannot modify jobs",
    update_createdByUser: "Can modify jobs they created",
    update_assignedToUser: "Can modify jobs assigned to them",
    update_role: "Can modify all jobs",
    update_role_PM: "Can modify jobs for assigned properties",
    create_none: "Cannot create jobs",
    create_role: "Can create jobs",
    create_role_PM: "Can create jobs for assigned properties",
  },
  property: {
    title: "Properties",
    read_none: "Disable all property pages",
    read_assignedToUser: "Can view assigned property details",
    read_role: "Can view all property details",
    update_none: "Cannot modify properties",
    update_assignedToUser: "Can modify assigned properties",
    update_role: "Can modify all properties",
    create_none: "Cannot create properties",
    create_role: "Can create properties",
  },
  property_group: {
    title: "Property Groups",
    read_none: "Disable all property group pages",
    read_assignedToUser: "Can view assigned property groups",
    read_role: "Can view property group details",
    update_none: "Cannot modify property groups",
    update_assignedToUser: "Can modify assigned property groups",
    update_role: "Can modify all property groups",
    create_none: "Cannot create property groups",
    create_role: "Can create property groups",
  },
  rule: {
    title: "Rules, Rulesets, and Violations",
    read_none: "Disable rule, ruleset, and violations pages",
    read_role: "Can view rules, rulesets, and violations",
    read_role_PM: "Can view rules and rulesets for assigned properties",
    update_none: "Cannot modify rules, rulesets, or violations",
    update_role: "Can modify rules, rulesets, and violations",
    update_role_PM: "Can modify rules and rulesets for assigned properties",
    create_none: "Cannot create rules, rulesets, or violations",
    create_role: "Can create rules, rulesets, and violations",
    create_role_PM: "Can create rules and rulesets for assigned properties",
  },
};

export default permissions;
